import { useMutation } from "@tanstack/react-query";
import { businessCardApi } from "../../../../../services/company-office/BusinessCard.service";
import { IBusinessCard } from "../models/IBusinessCard";

export const useBCCreate = () => {
  return useMutation({
    mutationFn: (body: IBusinessCard) => {
      const request = businessCardApi.toRequest(body);
      return businessCardApi.create(request);
    },
  });
};
